import { render, staticRenderFns } from "./withdrawDetail.vue?vue&type=template&id=2210ec2b&scoped=true&"
import script from "./withdrawDetail.vue?vue&type=script&lang=js&"
export * from "./withdrawDetail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawDetail.vue?vue&type=style&index=0&id=2210ec2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2210ec2b",
  null
  
)

export default component.exports